export function getOrThrow<K, V>(map: Map<K, V>, key: K): V {
  if (!map.has(key)) {
    throw new Error(`Key not found in map`);
  }

  // Using the ! assertion here since K could be a nullable type
  return map.get(key)!;
}
